var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-img',{class:_vm.className,attrs:{"height":_vm.height,"width":_vm.width,"src":_vm.light ? _vm.lightLogo : _vm.darkLogo,"contain":""}})}
var staticRenderFns = []

export { render, staticRenderFns }